@if (isLoading) {
  <app-data-loader [show]="true" [message]="message" [overlay]="overlay" [size]="size" />
}
